import React from 'react'
import styles from '@/pages/calldetail/index.module.scss'
import BusinessDetailFrame from '@/next/BusinessDetailFrame'

// Next variant of src/pages/calldetail; the business origin is rewritten at build time.
const businessWebUrl = 'https://combine-next.jarvisbro.com'

const CallDetail: React.FC = () => (
    <BusinessDetailFrame
        origin={businessWebUrl}
        path="/ai/call/details"
        page="call-detail"
        title="CallDetail"
        styles={{ container: styles.callDetailContainer, loading: styles.loadingContainer, iframe: styles.callDetailIframe }}
    />
)

export default CallDetail
